/* tslint:disable */
/* eslint-disable */
/**
 * Změňte.to Admin API
 * Změňte.to Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurveyPatchRequestDTO
 */
export interface SurveyPatchRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof SurveyPatchRequestDTO
     */
    description?: string;
}

export function SurveyPatchRequestDTOFromJSON(json: any): SurveyPatchRequestDTO {
    return SurveyPatchRequestDTOFromJSONTyped(json, false);
}

export function SurveyPatchRequestDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurveyPatchRequestDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function SurveyPatchRequestDTOToJSON(value?: SurveyPatchRequestDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
    };
}

